@if (isFooterBar) {
    <div class="footer-bar"></div>
}
<footer class="footer container--nav" [class]="'footer--' + footerStyle + '-style'">
    <div class="footer__top" [class.footer__top--with-splash-button]="showFooterButtonBackToSplashPage">
        <core-brand-logo category="FOOTER" additionalClasses="brand-logo--footer"></core-brand-logo>

        @if (showFooterButtonBackToSplashPage) {
            <a
                class="btn btn--employee-group"
                routerLink="/"
                [core-analytics]="{ action: 'Change Employee Group', category: 'FOOTER' }">
                <div class="btn--employee-group__content">
                    <span class="btn--employee-group__label">{{ 'CHANGE EMPLOYEE GROUP' | translate }}</span>
                    <span class="btn--employee-group__value">{{ 'Employee Group Name' | translate }}</span>
                </div>
                <div class="btn--employee-group__action">
                    <span class="btn--employee-group__select">{{ 'Select' | translate }}</span>
                    <svg
                        class="btn--employee-group__icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5 12H19M19 12L12 5M19 12L12 19"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </a>
        }

        @if (pages$ | async; as _pages) {
            @if (!hideFooterLinksOnSplashLanding) {
                <ul class="footer-links-list">
                    @for (page of $any(_pages | orderBy: ['displayOrder']); track page) {
                        @if (
                            (page.meta.showFooterBar === "'true'" ||
                                page.meta.showFooterBar === true ||
                                page.meta.showFooterBar === 'true') &&
                            !['Login', 'Logout', 'Log in', 'Log out'].includes(page.name)
                        ) {
                            <li class="footer-links-list__item">
                                @if (page.meta.redirect && page.meta.redirect.startsWith('https://')) {
                                    <a
                                        [core-analytics]="{ action: page.url, category: 'FOOTER' }"
                                        [href]="page.meta.redirect"
                                        [innerText]="page.name"
                                        class="footer-links-list__link"
                                        target="_blank"></a>
                                } @else {
                                    <a
                                        [core-analytics]="{ action: page.url, category: 'FOOTER' }"
                                        [innerText]="page.name"
                                        [routerLink]="
                                            page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url
                                        "
                                        class="footer-links-list__link"></a>
                                }
                            </li>
                        }
                    }
                </ul>
            }
        }
    </div>

    @if (footerStyle === 'divided') {
        <hr class="footer__divider" />
    }

    <div class="footer__bottom">
        <p class="footer__copyright">
            &copy; {{ year }} Gallagher. &nbsp;<span [innerText]="'All Rights Reserved' | translate"></span>.
            &nbsp;<span [innerText]="'Powered by Core' | translate"></span>.
        </p>

        @if (pages$ | async; as _pages) {
            <ul class="footer-links-list footer-links-list--bottom">
                @for (infoPage of $any(_pages | orderBy: ['displayOrder']); track infoPage) {
                    @if (
                        infoPage.meta.showFooterBarBottom === "'true'" ||
                        infoPage.meta.showFooterBarBottom === true ||
                        infoPage.meta.showFooterBarBottom === 'true'
                    ) {
                        <li class="footer-links-list__item">
                            @if (
                                infoPage.meta.redirect &&
                                (infoPage.meta.redirect.startsWith('http://') ||
                                    infoPage.meta.redirect.startsWith('https://'))
                            ) {
                                <a
                                    [core-analytics]="{ action: infoPage.url, category: 'FOOTER' }"
                                    [href]="infoPage.meta.redirect"
                                    [innerText]="infoPage.name"
                                    class="footer-links-list__link"
                                    target="_blank">
                                </a>
                            } @else {
                                <a
                                    [core-analytics]="{ action: infoPage.url, category: 'FOOTER' }"
                                    [innerText]="infoPage.name"
                                    [routerLink]="
                                        infoPage.url === 'default' ? '/' : infoPage.meta.redirect || '/' + infoPage.url
                                    "
                                    class="footer-links-list__link">
                                </a>
                            }
                        </li>
                    }
                }
                @if (cookiePolicy) {
                    <li class="footer-links-list__item">
                        <a
                            [core-analytics]="{ action: 'Cookie policy', category: 'FOOTER' }"
                            [href]="'//policy.cookiereports.com/' + cookiePolicy + '-en-gb.html'"
                            [innerText]="'Cookie Policy' | translate"
                            class="footer-links-list__link">
                        </a>
                    </li>
                }
            </ul>
        }
    </div>

    @if (disclaimer) {
        <p class="footer__disclaimer">{{ disclaimer }}</p>
    }
</footer>
